import React, { useCallback, useMemo, useRef, useStat, useEffect } from 'react';
import { useStore } from '../../store';
import { useNavigate, useParams, Link } from 'react-router-dom';
import DataSheetInput from '../Inputs/DatasheetInput';

function List() {
  const { isAuthed, translation } = useStore();
  const { type } = useParams();
  const navigate = useNavigate();

  const ViewColumn = useMemo(() => ({
    component: ({ rowData, deleteRow }) => (
      <div className='w-full h-full flex justify-center'>
        {type === "drafts" ? (
          <button
            type='button'
            className='text-center w-full h-full'
            onClick={() => navigate(`/form/${btoa(rowData.recordId)}`)}
          >
            Edit
          </button>
        ) : null}
        <button
          type='button'
          className='text-center w-full h-full border-l border-gray-300'
          onClick={() => navigate(`/form/${btoa(rowData.recordId)}/pdf`)}
        >
          View
        </button>
        {type === "drafts" ? (
          <button
            type='button'
            className='text-center w-4/5 h-full border-l border-gray-300'
            onClick={() => {
              deleteRow();
            }}
          >
            ❌
          </button>
        ) : null}
      </div>
    ),
    basis: type === "drafts" ? 150 : 100
  }), [type, translation]);

  useEffect(() => {
    if (!isAuthed) {
      navigate("/auth");
    }
  }, [isAuthed]);

  const dfrFilter = useCallback(
    (dfr) =>
      type !== "history"
        ? dfr?.recordId < 0 &&
        (type === "pending" ? dfr?.submitted : !dfr?.submitted)
        : dfr.recordId > 0,
    [type]
  );

  const dfrDefault = useMemo(() => {
    return {};
  }, []);

  const dfrColumns = useMemo(
    () => [
      ["date", { title: translation.date, isCellEmpty: () => false, disabled: () => true }],
      ["jobNumber", { title: translation.jobNumber, isCellEmpty: () => false, disabled: () => true }],
      ["workOrderNumber", { title: translation.workOrderNum, isCellEmpty: () => false, disabled: () => true }],
      ["notes", { title: translation.notes, isCellEmpty: () => false, disabled: () => true }]
    ],
    [translation]
  );

  return (
    <div className='flex flex-col items-center py-4 gap-6'>
      <div className='lg:w-3/4 w-full px-4'>
        <DataSheetInput
          tableName={"dailyFieldReports"}
          filter={dfrFilter}
          defaultValues={dfrDefault}
          columns={dfrColumns}
          label={translation[type]}
          stickyRightColumn={ViewColumn}
          height={window.innerHeight - 400}
          addRowsComponent={false}
        />
      </div>
    </div>
  );
}

export default List;
